import type { SVGProps } from "react";
// generated from Sharp.svg — do not edit manually
// prettier-ignore
export default function Sharp(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M3 8H21M8 3L8 21M16 3L16 21M3 16H21" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
